import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import {
  GroupAssignmentModalData,
  GroupAssignmentModalOperation,
} from './group-assignment-modal-data';

export enum GroupAssignmentConfirmationModalResult {
  MoveAllItems = 'move_all_items',
  MoveSelectedItem = 'move_selected_item',
}

@Component({
  selector: 'wilson-group-assignment-confirmation-modal',
  imports: [NzModalModule, TranslateModule, NzButtonModule],
  templateUrl: './group-assignment-confirmation-modal.component.html',
  styleUrls: ['./group-assignment-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupAssignmentConfirmationModalComponent {
  private readonly modalRef = inject(NzModalRef);
  private readonly modalData = inject<GroupAssignmentModalData | null>(
    NZ_MODAL_DATA,
    { optional: true },
  );

  protected readonly operation: GroupAssignmentModalOperation =
    this.modalData?.operation ?? 'assign';

  protected readonly titleKey =
    this.operation === 'unassign'
      ? 'page.shift_timeline.unassign_shift.group_assignment.title'
      : 'page.shift_timeline.assign_shift.group_assignment.title';

  protected readonly descriptionKey =
    this.operation === 'unassign'
      ? 'page.shift_timeline.unassign_shift.group_assignment.description'
      : 'page.shift_timeline.assign_shift.group_assignment.description';

  protected readonly moveAllItemsKey =
    this.operation === 'unassign'
      ? 'page.shift_timeline.unassign_shift.group_assignment.unassign_all_items'
      : 'page.shift_timeline.assign_shift.group_assignment.move_all_items';

  protected readonly moveSelectedItemKey =
    this.operation === 'unassign'
      ? 'page.shift_timeline.unassign_shift.group_assignment.unassign_selected_item'
      : 'page.shift_timeline.assign_shift.group_assignment.move_selected_item';

  handleCancel(): void {
    this.modalRef.destroy(null);
  }

  handleMoveAllItems(): void {
    this.modalRef.destroy(GroupAssignmentConfirmationModalResult.MoveAllItems);
  }

  handleMoveSelectedItem(): void {
    this.modalRef.destroy(
      GroupAssignmentConfirmationModalResult.MoveSelectedItem,
    );
  }
}
